module.exports = __webpack_public_path__ + "static/media/betterPlace_logo.7073aa3a.svg";